var divider_viewer_rtlignore_default = {
  "divider-container": "_03aqh",
  "divider-container--double": "jm7kF",
  "divider": "V55Yu",
  "divider--single": "QFPGd",
  "divider--double": "j4n-r",
  "divider--dashed": "okSId",
  "divider--dotted": "VW4Vc",
  "divider--small": "YagY4",
  "divider--medium": "iuI60",
  "divider--large": "OfQsg",
  "divider--left": "_-2kMN",
  "divider--center": "ToLU7",
  "divider--right": "Aoqdv",
  "svgFixerContainer": "USSwM",
  "emptyChar": "Xpwpz"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
